import { pushEcommerceEvent } from './dataLayer';

/**
 * view_promotion and select_promotion for on site banners and adverts.
 *
 * view_promotion is sent when the banner has actually been visible, not when
 * it is rendered somewhere below the fold, so the impression numbers can be
 * used to calculate a real click through rate per advert slot.
 */

const VISIBLE_RATIO = 0.5;
const VISIBLE_MS = 1000;

const readPromotion = (element) => {
    try {
        return JSON.parse(element.dataset.trackingPromotion);
    } catch (e) {
        return null;
    }
};

const trackView = (element) => {
    const promotion = readPromotion(element);
    if (!promotion) {
        return;
    }
    pushEcommerceEvent('view_promotion', promotion);
};

const onClick = (event) => {
    const element = event.target.closest('[data-tracking-promotion]');
    if (!element) {
        return;
    }
    const promotion = readPromotion(element);
    if (!promotion) {
        return;
    }
    pushEcommerceEvent('select_promotion', promotion);
};

export const initPromotionTracking = () => {
    const promotions = Array.from(
        document.querySelectorAll('[data-tracking-promotion]')
    );
    if (promotions.length === 0) {
        return;
    }

    document.addEventListener('click', onClick, true);

    if (!('IntersectionObserver' in window)) {
        // Without the observer we still want the impressions, just without the
        // visibility requirement.
        promotions.forEach(trackView);
        return;
    }

    const timers = new WeakMap();
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const element = entry.target;
                if (entry.isIntersecting) {
                    timers.set(
                        element,
                        window.setTimeout(() => {
                            trackView(element);
                            observer.unobserve(element);
                        }, VISIBLE_MS)
                    );
                } else {
                    window.clearTimeout(timers.get(element));
                }
            });
        },
        { threshold: VISIBLE_RATIO }
    );

    promotions.forEach((element) => observer.observe(element));
};
